exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-notification-icon{display:block}adp-notification-icon.black .notification-icon{color:#000}adp-notification-icon .notification-icon{position:relative;padding:0 5px;font-size:22px;color:#fff}adp-notification-icon .notification-icon:after{content:\"\";display:block;position:absolute;top:10%;left:55%;z-index:5;width:8px;height:8px;background-color:#d0011b;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpNotificationIcon/adpNotificationIcon.less
// module id = 594
// module chunks = 0